/**
 * For all API related types. We want to declare a minimal number of these and
 * instead use the generated client types instead, but sometimes we can't help
 * it, especially since we are in a transitional state at the moment where we
 * are only half using the generated client types.
 */
import groupBy from 'lodash/groupBy';
import { EventDTO, SloDTO, SloEventsDTO } from '@atlassiansox/phobos-client-ts';

import { mapObj } from '@/utils';
import { getStartOfDayUTC } from '@/controllers/slo-graph-controller/utils';

type RawEventDTO = {
  [k in keyof EventDTO]: EventDTO[k] extends Date | undefined ? string : EventDTO[k];
};
export type RawSloEvents = Record<string, RawEventDTO[]>;
export type CapabilitySLOEvents = {
  slo: SloDTO;
  events: EventDTO[];
};
// keyed by epoch millis since Date objects are not primitives and do not
// compare equal even when they hold the same value. These keys are always
// truncated to the day (UTC)
export type SloEvents = Record<number, EventDTO[]>;

export function SloEventsFromSingleSLO(json: RawSloEvents): SloEvents {
  return mapObj(json, ([date, rawEvents]) => ({
    [new Date(date).getTime()]: rawEvents.map(rawEvent => ({
      ...rawEvent,
      start: new Date(rawEvent.start),
      end: rawEvent.end ? new Date(rawEvent.end) : undefined,
    })),
  }));
}

export function FixCapabilitySLOEvents(json: CapabilitySLOEvents[]): SloEventsDTO[] {
  return json.map(slo => ({
    slo: slo.slo,
    events: slo.events.map(event => ({
      ...event,
      start: new Date(event.start),
      end: event.end ? new Date(event.end) : undefined,
    })),
  }));
}

export function SloEventsFromEventSummary(events: EventDTO[]): SloEvents {
  return groupBy(events, function(e) {
    return getStartOfDayUTC(new Date(e.start)).getTime();
  });
}
